<template>
    <div class="ownerChangeList">
      <van-notice-bar mode="closable" left-icon="volume-o" text="当前页面仅展示审核不通过的数据,请重新提交申请">
      </van-notice-bar>
      <van-card v-for="(item, index) in changeInfoData" :key="index">
        <div slot="title" >
          <van-row>
            <van-col span="18">
              <div class="titleContent"  style="padding:10px 10px 10px 10px" >{{item.address}}</div>
            </van-col>
            <van-col span="6">
              <div style="float:right;text-align: right;padding: 10% 0 0 0 " >
                <!--          <div class="titleContent" style="float:right" >未交</div>-->
                <van-button type="danger" size="small" align="float:right" style="text-align: right" v-if="item.state === '3'" plain>审核不通过</van-button>

              </div>
            </van-col>
          </van-row>
        </div>
        <div slot="desc" style="top:12px">
          <van-cell-group>
            <van-cell title="姓名" :value="item.ownerName" />
            <van-cell title="身份证号" :value="item.certNo" />
            <van-cell title="联系方式" :value="item.phoneNo" />
            <van-cell title="申请时间" :value="item.reqTime" />
            <van-cell title="审核意见" :value="item.remark" style="font-weight: bold"/>
<!--            <van-row type="flex" justify="center">-->
<!--              <van-col span="22" >-->
<!--                <van-button type="primary" size="normal" class="btn" @click="ownerDetail(item.changeId)">查 看</van-button>-->
<!--              </van-col>-->
<!--            </van-row>-->


          </van-cell-group>
        </div>
        <div class="footer" slot="footer">
        </div>
      </van-card>




    </div>
</template>

<script>

    import { fetchAuditOwnerInfo} from '@/api/maintainFund/maintainFund'
    import { NoticeBar } from 'vant';

    export default {
        name: "ownerChangeList",
        data() {
            return {
              changeInfoData: [],
              name:[],
              tel:[],
              createDate:[],
              changeId:[]
            }
        },
         created() {
           fetchAuditOwnerInfo().then(res => {
             //this.bindNumber = res.data.length;
             console.log("res.data="+res.data)
             this.changeInfoData = res.data;
             console.log("changeInfoData="+this.changeInfoData)
           })
         },
        mounted() {

        },
        watch: {

        },
        components: {
            VanNoticeBar: NoticeBar

        },
        methods: {

        },
    }
</script>

<style lang='scss' scoped>
    .ownerChange {
        height: 100vh;
        background: #f2f2f2;

        .btn {
            margin-top: 5%;
            border-radius: 5px;
            background-color: #2acba2 !important;
            border: 1px solid #2acba2 !important;
        }

        .footFont {
            font-weight: normal;
            font-size: 14px;
            color: #999;
        }
    }

    .regionList {
        z-index: 100;
        position: absolute;
        width: 100%;
        margin-left: 25%;
        display: inline !important;
        list-style: none;
        overflow-y: scroll;
        line-height: 2;
        border-radius: 6px;
        background: white;

    }
    .van-cell_value {
      min-width: 70%;
      display: inline-block;
      text-align: left;
      word-break: break-all;
    }
    .van-cell_red {
      color: #ff0000;
    }
    .flexs-eve{
      display: flex;justify-content: space-evenly;
      padding-top: 20px;
    }
    .flexs{
      display: flex;
    }
    .houses{
      justify-content: space-between;
      padding: 0 15px;
    }
    .padding-r5{
      padding-right: 5px;
    }

    .shadow{
      margin: 0 10px;
      box-shadow: 0px 0px 20px #9E9E9E;
      border-radius: 10px;
      padding: 10px;
    }
    .bg{
      //background-image: url(static/bg.png);color: white;
      padding: 5px 0 20px 0;
    }
    .img-cen{
      display: flex;flex-direction: column;justify-content: center;align-items: center;
    }
    .images{
      width: 50px;height: 50px;
      padding-bottom: 5px;
    }
    .depositMessage{
      font-family: '微软雅黑',
      sans-serif;font-weight: 400;
      font-style: normal;
      color: #F59A23;
      text-align: left;
      line-height: 28px;
    }
    .titleContent{
      font-size: 15px;
      border-width: 1px;
      display: inline-block;
      font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
      font-weight: 700;
      font-style: normal;
      text-align: left;
    }
    .van-cell__value--alone {
      color: #F59A23;
      text-align: left;
    }
    .btn {
      margin-top: 1%;
      margin-bottom: 1%;
      border-radius: 5px;
      background-color: #2acba2 !important;
      border: 1px solid #2acba2 !important;
      float: right;
      height:35px;
    }

</style>
